import { useMemo } from "react";
import { Select } from "../controls";
import { usePersistStore } from "../store";
import { useDisputeTypes } from "../hooks/queries";

const DisputeTypeDropdown = ({ name, value, onChange }: any) => {
  const { token } = usePersistStore((s: any) => s);
  const { data = [] } = useDisputeTypes(token);
  const cats = useMemo(
    () => (data || []).map((k: any) => ({ label: k?.name, value: k?._id })),
    [data]
  );

  return (
    <Select
      name={name}
      title="Choose..."
      options={cats}
      showFirstOption={true}
      value={value}
      onChange={onChange}
    />
  );
};

export default DisputeTypeDropdown;
